
import React from 'react';

export default function OrElement() {

    return (
        <div className="row or-element">
            <div class="col border-bottom"></div>
            <div class="col-2 or-element__or d-flex justify-content-center align-items-center">OR</div>
            <div class="col border-bottom"></div>
        </div>
    );
}